/*rutas para login, logaout, account y todo lo relacionado con la session principal*/
export default [
  {
    path: '/',
    name: 'Login',
    view: 'HomeLayout',
    folder: 'Layouts',
    meta: {
      requiresVisitor: true,
    }
  },
  {
    path: '/home',
    name: 'Home',
    view: 'Home',
    folder: 'views/Account',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/account/profile',
    name: 'Profile',
    view: 'Profile',
    folder: 'views/Account',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/account/organizations',
    name: 'Organizations',
    view: 'Organizations',
    folder: 'views/Account',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/account/organization/new',
    name: 'AddOrganization',
    view: 'AddOrganization',
    folder: 'views/Account',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/account/security',
    name: 'Security',
    view: 'Security',
    folder: 'views/Account',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/account/users',
    name: 'Users',
    view: 'Users',
    folder: 'views/Account',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/account/privilegies/:account_id',
    name: 'Privilegies',
    view: 'Privilegies',
    folder: 'views/Account',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/account/privilegies-group/:account_id/:org_id/:app_id',
    name: 'PrivilegiesList',
    view: 'PrivilegiesList',
    folder: 'views/Account',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    view: 'Logout',
    folder: 'components',
    meta: {
      requiresAuth: true,
    }
  }
];